import { Option, Value } from 'baseui/select';
import { useFormState } from 'components/elements/form';
import TableInput from 'components/elements/table/table-input';
import { ActionType } from 'components/elements/table/type';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import useGetCruiseGroupDetailTableList from './table-column';
import {
  CruiseSaleCruiseSaleDetailsFormType,
  CruiseSaleCruiseSaleGuestFormType,
  CruiseSaleFormType,
} from '../../form-type';

interface Props {
  parentIndex: number;
  guest: CruiseSaleCruiseSaleGuestFormType;
  cruiseRoomList: Option[];
}

export default function CruiseGuestDetailTable(props: Props) {
  const { editable } = useFormState();
  const detailsName =
    `cruiseSales.${props.parentIndex}.cruiseSaleDetails` as const;
  const { getValues, setValue, clearErrors } =
    useFormContext<CruiseSaleFormType>();

  const guestIndex = getValues(detailsName).findIndex(
    (item) => item.guestDetailId === props.guest.guestDetailId,
  );

  const columns = useGetCruiseGroupDetailTableList(props.cruiseRoomList);

  const dispatch = React.useCallback(
    (action) => {
      const details = getValues(detailsName);
      const currentRowIndex = guestIndex;
      const detail = details[currentRowIndex];
      const type = action.type as ActionType;
      const columnId =
        action.columnId as keyof CruiseSaleCruiseSaleDetailsFormType;
      const extra = action.extra as Value;
      const value = action.value;

      const otherVal: () => Partial<CruiseSaleCruiseSaleDetailsFormType> =
        () => {
          if (columnId === 'cruiseRoomId') {
            return {
              cruiseRoomName: extra?.[0]?.label as string,
            };
          }
          return {};
        };

      if (type === 'update_cell') {
        setValue(`${detailsName}.${guestIndex}`, {
          ...detail,
          [columnId]: value,
          ...otherVal(),
        });
        clearErrors(`${detailsName}.${guestIndex}.${columnId}`);
      }
    },
    [getValues, detailsName, guestIndex, setValue, clearErrors],
  );

  const detail = getValues(detailsName)[guestIndex];

  return (
    <div style={{ width: '100%' }}>
      <TableInput
        columns={columns}
        data={detail ? [detail] : []}
        dispatch={dispatch}
        disabled={!editable}
        noAddRemoveRow
        name={detailsName}
        uniqueRowKey="customId"
      />
    </div>
  );
}
